import { Link } from "@quintype/components";
import React from "react";
import "./e-paper-button.m.css";
import Arrow from "../other-icons/Arrow";

function EPaperButton() {
  return (
    <div styleName="wrapper">
      <Link href="https://epaper.deccanherald.com/" styleName="e-paper" target="_blank">
        ePaper <Arrow color="#E6B832" width="14px" height="14px" />
      </Link>
    </div>
  );
}

export default EPaperButton;
